var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1C11 0.447715 10.5523 0 10 0C9.44773 0 9.00002 0.447715 9.00002 1V11.8258L7.15081 10.2407C6.73148 9.88132 6.10018 9.92988 5.74076 10.3492C5.38134 10.7685 5.4299 11.3998 5.84923 11.7593L9.34923 14.7593C9.72372 15.0802 10.2763 15.0802 10.6508 14.7593L14.1508 11.7593C14.5701 11.3998 14.6187 10.7685 14.2593 10.3492C13.8999 9.92988 13.2686 9.88132 12.8492 10.2407L11 11.8258V1ZM2 14C2 13.4477 1.55228 13 1 13C0.447715 13 0 13.4477 0 14V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V14C20 13.4477 19.5523 13 19 13C18.4477 13 18 13.4477 18 14V17C18 17.5523 17.5523 18 17 18H3C2.44772 18 2 17.5523 2 17V14Z",
    fill: "#292F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/download_black.4624a1e7d6c919bf56d174dbe3f4d73d.svg";
export { ForwardRef as ReactComponent };